/*
 * File: UpdateStudent.ts
 * Author: Austin Robinson
 * Date Created: 7/28/2023
 * Copyright (c) DrivingDoc 2023
 */

import { ErrorResponse, privateApi } from 'api';
import { AxiosError } from 'axios';
import { StudentInfoFormValues } from 'pages/Student/StudentInformation/formSchema';
import { createMutation } from 'react-query-kit';

export interface UpdateStudentParams {
    id: string
    formValues: StudentInfoFormValues;
}

async function updateStudent({ id, formValues }: UpdateStudentParams): Promise<boolean> {
    // make api call
    await privateApi.put(`${import.meta.env.VITE_API_BASE_URL}/users/students/${id}`, formValues, {});

    // return the data object
    return true;
}

const useUpdateStudent = createMutation<boolean, UpdateStudentParams, AxiosError<ErrorResponse>>({
    mutationFn: async (variables: UpdateStudentParams) => updateStudent(variables),
});

export { updateStudent, useUpdateStudent };
